export {
  ButtonGroup,
  type ButtonGroupProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/ButtonGroup';
